import { z } from 'zod';
import { expectType, zDocument } from './model.js';
import { reverseKeys } from './util/reverseKeys.js';
export const AccountLookup = { token: 'Token Account', subscription: 'Subscription' };
export const AccountEnum = z.nativeEnum(reverseKeys(AccountLookup));
export const TransactionTypeLookup = { credit: 'Credit', debit: 'Debit' };
export const TransactionTypeEnum = z.nativeEnum(reverseKeys(TransactionTypeLookup));
export const TransactionReasonLookup = {
    promotion: 'Promotion',
    sponsorship: 'Sponsorship',
    refund: 'Refund',
    reward: 'Reward',
    withdrawal: 'Withdrawal',
    deposit: 'Deposit'
};
export const TransactionReasonEnum = z.nativeEnum(reverseKeys(TransactionReasonLookup));
export const TransactionStatusLookup = { pending: 'Pending', completed: 'Completed', failed: 'Failed' };
export const TransactionStatusEnum = z.nativeEnum(reverseKeys(TransactionStatusLookup));
export const zUserLedger = zDocument.extend({
    type: z.literal('userLedger'),
    user: z.string(),
    amount: z.number(),
    account: AccountEnum,
    transactionType: TransactionTypeEnum,
    transactionReason: TransactionReasonEnum,
    transactionDescription: z.string(),
    transactionStatus: TransactionStatusEnum,
    transactionError: z.string(),
    transactionErrorCode: z.number()
});
expectType({});
expectType({});
export const EmptyUserLedger = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'userLedger',
    account: 'token',
    user: '',
    amount: 0,
    transactionType: 'credit',
    transactionReason: 'deposit',
    transactionDescription: '',
    transactionStatus: 'pending',
    transactionError: '',
    transactionErrorCode: 0
};
